module.exports = __webpack_public_path__ + "img/new_bg_img.522b1e37.svg";